export default {
  TYPE_WORKSPACE: {
    USER: 'User',
    SYSTEM: 'System',
  },
  CURRENT_WORKSPACE_NAME: 'CURRENT_WORKSPACE_NAME',
};
